<template>
  <div class="container">
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div v-html="content.description"></div>
        <div>
          <ul>
            <li>
              <a href="../../documents/Private Policy.pdf" target="_blank">Private Policy</a>
            </li>
            <li>
              <a
                href="../../documents/Terms and Conditions LOVAL.pdf"
                target="_blank"
              >Terms and Conditions</a>
            </li>
          </ul>
        </div>
        <div><p><strong>Disclaimer:</strong> Loval Electrics &amp; Automation Ltd / UG sells new and surplus products and develops channels to purchase such product. This website is not sanctioned or approved by any manufacturer or tradename listed.</p>
<p>Loval Electrics &amp; Automation Ltd / UG is not an authorized distributor, affiliate, or representative for the listed manufacturers unless explicitly stated otherwise. Designated trademarks, brand names and brands appearing herein are the property of their respective owners.</p></div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from '../LovalFooter'
export default {
  components: {
    LovalFooter
  },
  props: ['content', 'links'],
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
.scrollable {
  height: calc(100% - var(--loval-footer-height));
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
a {
  color: inherit;
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
}
</style>
